<template>
    <news-detail
        :id="id"
        @close="close"
    ></news-detail>
</template>

<script>
    import NewsDetail from "../News/detail";

    export default {
        name: "News",
        props: ["id"],
        components: {
            "news-detail": NewsDetail
        },
        methods: {
            close() {
                this.$router.back();
            }
        },
        mounted() {
            this.$emit("header", false);
        },
        destroyed() {
            this.$emit("header", true);
        }
    }
</script>